module.exports = __webpack_public_path__ + "static/media/logo_hubert.58b913bc.svg";